module.exports = __webpack_public_path__ + "static/media/sama3.29885f82.wav";